import React from "react";
import Marquee from "../components/Marquee";

export default function Sourcing() {
  return (
    <div data-testid="sourcing-page" className="pt-28 pb-24">
      <section className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-6">From the soil that grew it</p>
        <h1 className="font-serif-display text-6xl md:text-8xl tracking-tighter leading-[0.92] max-w-5xl">
          We know the farmer<br/>
          <em className="text-[#C84B31] not-italic">by name.</em>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 mt-20 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="aspect-[4/5] bg-[#EAE6DB] overflow-hidden">
          <img src="https://images.pexels.com/photos/14262717/pexels-photo-14262717.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720" alt="Saffron farms" className="w-full h-full object-cover"/>
        </div>
        <div className="self-center">
          <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-3">Kashmir · Saffron</p>
          <h2 className="font-serif-display text-5xl tracking-tighter">A 7-day window<br/>in November.</h2>
          <p className="mt-6 text-[#4A4A4A] leading-relaxed text-lg">
            Our saffron is harvested by hand in Pampore, Kashmir, during the brief
            autumn bloom. Threads are separated from the petals the same evening,
            cold-dried, then graded by ISO 3632 lab in Srinagar before shipping.
          </p>
        </div>
      </section>

      <Marquee />

      <section className="max-w-7xl mx-auto px-6 md:px-12 mt-20 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="self-center order-2 md:order-1">
          <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-3">Sundarban & Himalaya · Honey</p>
          <h2 className="font-serif-display text-5xl tracking-tighter">Wild hives,<br/>traditional hunters.</h2>
          <p className="mt-6 text-[#4A4A4A] leading-relaxed text-lg">
            We work with Mowali honey-hunters in the Sundarban mangroves
            and small apiaries above 2,500m in Uttarakhand. The honey is
            cold-extracted, never pasteurised, and packed at source.
          </p>
        </div>
        <div className="aspect-[4/5] bg-[#EAE6DB] overflow-hidden order-1 md:order-2">
          <img src="https://images.pexels.com/photos/12397403/pexels-photo-12397403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720" alt="Honey jars" className="w-full h-full object-cover"/>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 mt-20 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="aspect-[4/5] bg-[#EAE6DB] overflow-hidden">
          <img src="https://images.pexels.com/photos/5504609/pexels-photo-5504609.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720" alt="Spices" className="w-full h-full object-cover"/>
        </div>
        <div className="self-center">
          <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-3">Western Ghats · Spices</p>
          <h2 className="font-serif-display text-5xl tracking-tighter">Pepper, cardamom,<br/>turmeric, chilli.</h2>
          <p className="mt-6 text-[#4A4A4A] leading-relaxed text-lg">
            Sourced from family estates in Kerala, Karnataka and Andhra Pradesh.
            Sun-dried, hand-sorted, milled in micro-batches and packed with
            nitrogen-flushed barrier liners for export shelf life.
          </p>
        </div>
      </section>
    </div>
  );
}
